document.addEventListener('DOMContentLoaded', function () {
  async function stripOffProps() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const updates = {};
      cart.items.forEach(item => {
        if (item.properties) {
          Object.keys(item.properties).forEach(key => {
            const val = String(item.properties[key]).toLowerCase();
            if (val === 'off') {
              const cleaned = { ...item.properties };
              delete cleaned[key];
              updates[item.key] = cleaned;
            }
          });
        }
      });
      for (const key in updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, properties: updates[key] })
        });
      }
    } catch (e) {}
  }
  stripOffProps();
  document.addEventListener('cart:updated', stripOffProps);
  document.addEventListener('cart:refresh', stripOffProps);
});